export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const loanTypes = [
  { text: 'Plan 1 (Uni before 2012)', value: 'Type 1' },
  { text: 'Plan 2 (Uni on/after 2012)', value: 'Type 2' },
  { text: 'Plan 4 (Scottish Students)', value: 'Type 4' },
  { text: 'Postgraduate Loan', value: 'Postgraduate' },
]

export const graduationYearOptions = () => {
  const currentYear = new Date().getFullYear()
  const arr = []

  for (let i = currentYear; i > currentYear - 50; i--) {
    arr.push({ text: i, value: i })
  }
  return arr
}

export const formatNumber = (no: string) => parseFloat(no.replace(/,/g, ''))
